export function PMSUser({
    uid,
    name,
    email,
    highestPlan = 0,
} = {}) {
    return {
        uid,
        name,
        email,
        highestPlan,
    };
}